import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenerateRouteService } from '../../service/generate-route.service';
import { CheckCorrectRouteService } from '../../routes/check-correct-route.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent implements OnInit {
  constructor(
    private generateRouteService: GenerateRouteService,
    private checkCorrectRouteService: CheckCorrectRouteService,
    private router: Router
  ) { }

  /**
   * Inicializa el componente y redirecciona a la ruta correcta si la encuentra en otro idioma
   */
  ngOnInit(): void {
    const currentUrl = this.router.url;
    const translatedRoute = this.checkCorrectRouteService.findRouteInOtherLanguage(currentUrl);
    if (translatedRoute) {
      this.router.navigateByUrl(translatedRoute);
    } else {
    }
  }

  /**
   * Obtiene la ruta en función del idioma seleccionado
   * @param routeKey
   * @returns
   */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }
}
